import { TableUtils } from '../../jscaip/TableUtils';
import { GameStateWithTable } from '../../jscaip/state/GameStateWithTable';
import { GoPiece } from './GoPiece';
export class GoState extends GameStateWithTable {
    static of(oldState, newBoard) {
        return oldState.withBoard(newBoard);
    }
    koCoord;
    captured;
    phase;
    constructor(board, captured, turn, koCoord, phase) {
        super(board, turn);
        this.captured = captured;
        this.captured.makeImmutable();
        this.koCoord = koCoord;
        this.phase = phase;
    }
    getCapturedCopy() {
        return this.captured.getCopy();
    }
    static getStartingBoard(width, height) {
        return TableUtils.create(width, height, GoPiece.EMPTY);
    }
    isDead(coord) {
        return this.getPieceAt(coord).isDead();
    }
    isTerritory(coord) {
        return this.getPieceAt(coord).isTerritory();
    }
    withBoard(board) {
        return new GoState(board, this.captured, this.turn, this.koCoord, this.phase);
    }
    incrementTurn() {
        return new GoState(this.board, this.captured, this.turn + 1, this.koCoord, this.phase);
    }
    withCaptures(newCaptured) {
        return new GoState(this.board, newCaptured, this.turn, this.koCoord, this.phase);
    }
    withAddedCaptures(player, captures) {
        const newCaptured = this.getCapturedCopy();
        newCaptured.add(player, captures);
        return this.withCaptures(newCaptured);
    }
    withKo(newKo) {
        return new GoState(this.board, this.captured, this.turn, newKo, this.phase);
    }
    withPhase(newPhase) {
        return new GoState(this.board, this.captured, this.turn, this.koCoord, newPhase);
    }
    withPieceAt(coord, value) {
        return GameStateWithTable.setPieceAt(this, coord, value, GoState.of);
    }
}
